module.exports = __webpack_public_path__ + "img/map_1791458177610_76000.d45d6de1.jpg";